import { createRoot } from "react-dom/client";
import { supabase, supabaseConfigError } from "@/integrations/supabase/client";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";
import { bindMonitoringToSupabaseAuth, initializeMonitoring } from "@/lib/monitoring";
import { initializeProductAnalytics } from "@/domain/telemetry/productAnalyticsProvider";
import App from "./App.tsx";
import "./index.css";

void initializeMonitoring();
if (!supabaseConfigError) {
  bindMonitoringToSupabaseAuth(supabase);
}
void initializeProductAnalytics();

createRoot(document.getElementById("root")!).render(
  <AppErrorBoundary>
    {supabaseConfigError ? <SupabaseConfigError message={supabaseConfigError} /> : <App />}
  </AppErrorBoundary>,
);

function SupabaseConfigError({ message }: { message: string }) {
  return (
    <main className="min-h-screen bg-slate-50 px-6 py-16 text-slate-900">
      <div className="mx-auto max-w-2xl rounded-lg border border-red-200 bg-white p-6 shadow-sm">
        <p className="text-sm font-semibold uppercase tracking-wide text-red-700">Configuração Supabase em falta</p>
        <h1 className="mt-2 text-2xl font-semibold">Não foi possível iniciar o Orzio</h1>
        <p className="mt-3 text-sm leading-6 text-slate-600">
          {message}. Configure as variáveis públicas do Vite no ambiente de produção da Vercel e faça novo deploy.
        </p>
      </div>
    </main>
  );
}
